import { cn } from "@/src/shared/utils/mergeTwClasses";
import { Step, StepConnector, StepLabel, Stepper } from "@mui/material";
import { FC } from "react";
import { StepperProps } from "../lib/type";
import { DesktopStepIcon } from "./DesktopStepIcon";

export const DesktopStepper: FC<StepperProps> = ({
    steps,
    stepperProps,
    stepProps,
    stepLabelProps,
    activeStep = 0,
    percent = 0,
}) => {
    return (
        <Stepper
            activeStep={activeStep}
            connector={<StepConnector />}
            className={cn(`max-mdPlus:hidden`, stepLabelProps?.className)}
            {...stepperProps}
        >
            {steps.map((label, index) => (
                <Step key={index} {...stepProps}>
                    <StepLabel
                        className={cn(stepLabelProps?.className)}
                        StepIconComponent={(props) => {                          
                           return <DesktopStepIcon {...props} stepNumber={index + 1} percent={percent} />
                        }}
                    >
                        {label}
                    </StepLabel>
                </Step>
            ))}
        </Stepper>
    );
};
